<template lang="pug">
#app
  .container
    .row
      .header
        h1 Enkele interactieve applicaties
    .row
      .col-4(v-for="item of toc" v-key="item.id")
        .card
          img.card-img-top(:src="item.image" :alt="item.name")
          .card-body
            a.stretched-link(:href="item.page") {{ item.name }}
</template>

<script>
import imgComplex from "./assets/complex.png";
import imgFourier from "./assets/fourier.png";
import imgODE from "./assets/ode.png";

export default {
  name: "App",
  data: () => {
    return {
      toc: [
        {
          id: "complex",
          name: "Complex functions",
          page: "complex.html",
          image: imgComplex,
        },
        {
          id: "ode",
          name: "Methods for ODEs",
          page: "ode.html",
          image: imgODE,
        },
        {
          id: "fourier",
          name: "Fourier transform",
          page: "fourier.html",
          image: imgFourier,
        },
      ],
    };
  },
};
</script>

<style></style>
